/**
 * 检查路径是否为外部链接
 * @param {string} path 路径
 * @returns {boolean} 是否为外部链接
 */
export function isExternal(path: string): boolean {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * 验证用户名是否有效
 * @param {string} str 用户名
 * @returns {boolean} 是否有效
 */
export function validUsername(str: string): boolean {
  const valid_map: string[] = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * 验证URL是否有效
 * @param {string} url URL地址
 * @returns {boolean} 是否有效
 */
export function validURL(url: string): boolean {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * 验证字符串是否全为小写字母
 * @param {string} str 字符串
 * @returns {boolean} 是否有效
 */
export function validLowerCase(str: string): boolean {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * 验证字符串是否全为大写字母
 * @param {string} str 字符串
 * @returns {boolean} 是否有效
 */
export function validUpperCase(str: string): boolean {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * 验证字符串是否全为字母
 * @param {string} str 字符串
 * @returns {boolean} 是否有效
 */
export function validAlphabets(str: string): boolean {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * 验证邮箱是否有效
 * @param {string} email 邮箱地址
 * @returns {boolean} 是否有效
 */
export function validEmail(email: string): boolean {
  const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * 判断是否为字符串类型
 * @param {unknown} str 待检测的值
 * @returns {boolean} 是否为字符串
 */
export function isString(str: unknown): boolean {
  return typeof str === 'string' || str instanceof String
}

/**
 * 判断是否为数组类型
 * @param {unknown} arg 待检测的值
 * @returns {boolean} 是否为数组
 */
export function isArray(arg: unknown): boolean {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
} 